export enum ContentType {
  FIELD = 'Field',
  FUNCTION = 'Function',
  BASE_CONDITION = 'BASE_CONDITION',
  VALUE = 'Value'
}
